// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"f6143d8d","718":"6db391c0","838":"26cfcba6","921":"e30a1725"}[chunkId] + ".chunk.js";
};